import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { NotebookPen, Eye, EyeOff } from "lucide-react";
import { AGENDA_CATS } from "@/components/AgendaPanel";

// Agenda Personale dell'assistito, consultabile dall'operatore (sola lettura)
export const AdminUserAgenda = ({ userId }) => {
  const [entries, setEntries] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setEntries(null); setShow(false);
    api.get(`/admin/users/${userId}/agenda`).then((r) => setEntries(r.data.entries || [])).catch(() => setEntries([]));
  }, [userId]);

  return (
    <div className="paper-card p-4 mb-6" data-testid="admin-user-agenda-panel">
      <div className="flex items-center gap-2 mb-3">
        <NotebookPen className="w-5 h-5 text-labor-terracotta" />
        <h3 className="font-display text-lg">Agenda Personale</h3>
        <span className="text-xs text-labor-muted">({entries?.length ?? 0} note)</span>
        {entries?.length > 0 && (
          <button data-testid="admin-agenda-toggle" onClick={() => setShow(!show)} className="ml-auto text-xs border border-labor-border px-3 py-1 flex items-center gap-1 hover:bg-labor-skyBg">
            {show ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />} {show ? "Nascondi" : "Mostra contenuti"}
          </button>
        )}
      </div>
      {entries?.length === 0 && <div className="text-sm text-labor-muted">L'assistito non ha salvato note.</div>}
      <div className="space-y-2">
        {(entries || []).map((e) => (
          <div key={e.id} className="border border-labor-border p-3 text-sm" data-testid={`admin-agenda-entry-${e.id}`}>
            <div className="flex items-center gap-2"><span className="text-[10px] uppercase bg-labor-olive text-white px-2 py-0.5">{AGENDA_CATS[e.category]}</span><strong>{e.title}</strong></div>
            <div className="mt-1 font-mono whitespace-pre-wrap break-words text-labor-ink">{show ? e.content : "••••••••••"}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
